// extracted by mini-css-extract-plugin
module.exports = {"bg":"thank-you_bg__8VbTG","border":"thank-you_border__QnlkV","greenBorder":"thank-you_greenBorder__3YO4Y","header-video":"thank-you_header-video__c1uN6"};